import CommonDDService from "../../services/CommonDDService";
export default {
  namespaced: true,
  state: {
    allEnqPriceEnginePORDDList: [],
    allEnqPriceEnginePOLDDList: [],
    allEnqPriceEnginePODDDList: [],
    allEnqPriceEngineFPODDDList: [],

    allEnqPriceEngineIMPPORDDList: [],
    allEnqPriceEngineIMPPOLDDList: [],
    allEnqPriceEngineIMPPODDDList: [],
    allEnqPriceEngineIMPFPODDDList: [],

    allEnqPriceEngineCrossCountryDDList: [],
    allEnqPriceDDList: [],

    allEnqPriceEnginePICKDDList: [],
    allEnqPriceEngineHANDDDList: [],
    allEnqPriceEngineSTUFFDDList: [],
  },
  getters: {
    getAllEnqPriceEnginePORDDList: (state) => state.allEnqPriceEnginePORDDList,
    getAllEnqPriceEnginePOLDDList: (state) => state.allEnqPriceEnginePOLDDList,
    getAllEnqPriceEnginePODDDList: (state) => state.allEnqPriceEnginePODDDList,
    getAllEnqPriceEngineFPODDDList: (state) => state.allEnqPriceEngineFPODDDList,

    getAllEnqPriceEngineIMPPORDDList: (state) => state.allEnqPriceEngineIMPPORDDList,
    getAllEnqPriceEngineIMPPOLDDList: (state) => state.allEnqPriceEngineIMPPOLDDList,
    getAllEnqPriceEngineIMPPODDDList: (state) => state.allEnqPriceEngineIMPPODDDList,
    getAllEnqPriceEngineIMPFPODDDList: (state) => state.allEnqPriceEngineIMPFPODDDList,

    getAllEnqPriceEngineCrossCountryDDList: (state) => state.allEnqPriceEngineCrossCountryDDList,
    getAllEnqPriceDDList: (state) => state.allEnqPriceDDList,

    getAllEnqPriceEnginePICKDDList: (state) => state.allEnqPriceEnginePICKDDList,
    getAllEnqPriceEngineHANDDDList: (state) => state.allEnqPriceEngineHANDDDList,
    getAllEnqPriceEngineSTUFFDDList: (state) => state.allEnqPriceEngineSTUFFDDList,
  },

  mutations: {
    SET_ALL_ENQ_PRICE_ENGINE_POR_DD_LIST(state, val) {
      state.allEnqPriceEnginePORDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_POL_DD_LIST(state, val) {
      state.allEnqPriceEnginePOLDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_POD_DD_LIST(state, val) {
      state.allEnqPriceEnginePODDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_FPOD_DD_LIST(state, val) {
      state.allEnqPriceEngineFPODDDList = val;
    },


    SET_ALL_ENQ_PRICE_ENGINE_IMP_POR_DD_LIST(state, val) {
      state.allEnqPriceEngineIMPPORDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_IMP_POL_DD_LIST(state, val) {
      state.allEnqPriceEngineIMPPOLDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_IMP_POD_DD_LIST(state, val) {
      state.allEnqPriceEngineIMPPODDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_IMP_FPOD_DD_LIST(state, val) {
      state.allEnqPriceEngineIMPFPODDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_CROSS_COUNTRY_LOCATION_DD_LIST(state, val) {
      state.allEnqPriceEngineCrossCountryDDList = val;
    },

    SET_ALL_ENQ_PRICE_DD_LIST(state, val) {
      state.allEnqPriceDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_PICK_DD_LIST(state, val) {
      state.allEnqPriceEnginePICKDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_HAND_DD_LIST(state, val) {
      state.allEnqPriceEngineHANDDDList = val;
    },

    SET_ALL_ENQ_PRICE_ENGINE_STUFF_DD_LIST(state, val) {
      state.allEnqPriceEngineSTUFFDDList = val;
    },


  },
  actions: {
    // Export DropDown Start
    setAllEnqPriceEnginePORDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_POR_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEnginePORDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_POR_DD_LIST", response.data.getAllEnqPriceEnginePORDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEnginePORDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEnginePORDDList ", err);
        });
    },

    setAllEnqPriceEnginePOLDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_POL_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEnginePOLDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_POL_DD_LIST", response.data.getAllEnqPriceEnginePOLDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEnginePOLDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEnginePOLDDList ", err);
        });
    },

    setAllEnqPriceEnginePODDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_POD_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEnginePODDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_POD_DD_LIST", response.data.getAllEnqPriceEnginePODDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEnginePODDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEnginePODDDList ", err);
        });
    },

    setAllEnqPriceEngineFPODDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_FPOD_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineFPODDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_FPOD_DD_LIST", response.data.getAllEnqPriceEngineFPODDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEnginePODDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEngineFPODDDList ", err);
        });
    },
    // Export DropDown End

    // Import DropDown Start
    setAllEnqPriceEngineIMPPORDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_POR_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineIMPPORDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_POR_DD_LIST", response.data.getAllEnqPriceEngineIMPPORDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEnginePORDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEngineIMPPORDDList ", err);
        });
    },

    setAllEnqPriceEngineIMPPOLDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_POL_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineIMPPOLDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_POL_DD_LIST", response.data.getAllEnqPriceEngineIMPPOLDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEngineIMPPOLDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEngineIMPPOLDDList ", err);
        });
    },

    setAllEnqPriceEngineIMPPODDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_POD_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineIMPPODDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_POD_DD_LIST", response.data.getAllEnqPriceEngineIMPPODDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEngineIMPPODDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEngineIMPPODDDList ", err);
        });
    },

    setAllEnqPriceEngineIMPFPODDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_FPOD_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineIMPFPODDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_IMP_FPOD_DD_LIST", response.data.getAllEnqPriceEngineIMPFPODDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getgetAllEnqPriceEngineIMPFPODDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEngineIMPFPODDDList ", err);
        });
    },

    setAllEnqPriceEngineCrossCountryLocationDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_CROSS_COUNTRY_LOCATION_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          console.log("SET_ALL_ENQ_PRICE_ENGINE_CROSS_COUNTRY_LOCATION_DD_LIST=>", response.data);
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineCrossCountryDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_CROSS_COUNTRY_LOCATION_DD_LIST", response.data.getAllEnqPriceEngineCrossCountryDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getgetAllEnqPriceEngineIMPFPODDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getgetAllEnqPriceEngineIMPFPODDDList ", err);
        });
    },
    // Import DropDown End

    setAllEnqPriceEnginePICKDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_PICK_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEnginePICKDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_PICK_DD_LIST", response.data.getAllEnqPriceEnginePICKDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEnginePICKDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllEnqPriceEnginePICKDDList ", err);
        });
    },

    setAllEnqPriceEngineHANDDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_HAND_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineHANDDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_HAND_DD_LIST", response.data.getAllEnqPriceEngineHANDDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEngineHANDDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllEnqPriceEngineHANDDDList ", err);
        });
    },

    setAllEnqPriceEngineSTUFFDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_ENGINE_STUFF_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllEnqPriceEngineSTUFFDDList
          ) {
            await commit("SET_ALL_ENQ_PRICE_ENGINE_STUFF_DD_LIST", response.data.getAllEnqPriceEngineSTUFFDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceEngineSTUFFDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllEnqPriceEngineSTUFFDDList ", err);
        });
    },

    setAllEnqPriceDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_PRICE_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          console.log("SET_ALL_ENQ_PRICE_DD_LIST=>", response.data);
          if (
            response.status == 200 &&
            response.data &&
            response.data.getEngPricingList
          ) {
            await commit("SET_ALL_ENQ_PRICE_DD_LIST", response.data.getEngPricingList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllEnqPriceDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllEnqPriceDDList ", err);
        });
    },


  },
};



// WEBPACK FOOTER //
// ./src/store/module/enqPriceEngineDropdown.js